module.exports = __webpack_public_path__ + "static/img/mobile-page.76870da9.jpg";